import { CollectionItem } from '@/data/schema/collection-item'

/**
 * Pass in Items array, return all items and kit components
 * @param items CollectionItem[]
 * @returns CollectionItem[]
 */
export function getAllItems(items: CollectionItem[]): CollectionItem[] {
	return items.flatMap((item) => [item, ...(item.kit_components || [])])
}

export function splitWeightByDepot(items: CollectionItem[]): { [depot: string]: number } {
	const depotWeightMap = getAllItems(items)
		.map((item) => {
			return {
				depot: item.depot,
				weight: item.item_weight
			}
		})
		.filter(
			(item) =>
				item.depot !== undefined && typeof item.weight === 'number' && !isNaN(item.weight)
		)

	const weightByDepotMap: { [depot: string]: number } = {}

	depotWeightMap.forEach((item) => {
		if (!weightByDepotMap[item.depot!]) {
			weightByDepotMap[item.depot!] = 0
		}

		weightByDepotMap[item.depot!] += item.weight!
	})

	return weightByDepotMap
}
